// components/AppErrorBoundary.jsx
import React from "react";
import { logger } from "../utils/logger";

export default class AppErrorBoundary extends React.Component {
  state = { hasError: false, err: null };

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(err, info) {
    try {
      const renderError = err instanceof Error ? err : new Error(String(err || "Render error"));
      logger?.error?.(renderError, {
        event: "render error",
        componentStack: info?.componentStack || "",
      });
    } catch (_) {
      // Zorg dat logging nooit zelf crasht
    }
  }

  componentDidUpdate(prevProps) {
    // Reset automatisch als een "reset key" verandert (bijv. route, entity-id, etc.)
    if (this.props.resetKey !== prevProps.resetKey) {
      // Alleen resetten als we in error state zitten
      if (this.state.hasError) this.setState({ hasError: false, err: null });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, err: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-red-50 text-red-800 rounded space-y-3">
          <div className="font-medium">Er ging iets mis in de weergave.</div>
          <div className="text-sm opacity-80">
            Vernieuw de pagina of probeer opnieuw.
          </div>
          <button
            onClick={this.handleRetry}
            className="px-3 py-1.5 rounded bg-red-600 text-white"
          >
            Probeer opnieuw
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
